import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import {
  getDailyLoadCarriers, linkDailyLoadCarrier, searchCarriers, unlinkDailyLoadCarrier,
} from '../../../../app/store/actions/dailyLoadCarriers';
import OneClickButton from '../../../../components/form/button';
import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';
import ROUTES from '../../../../config/routes';

class CarrierLinkDailyLoadsForm extends React.Component {
  constructor(props) {
    super(props);

    this.tableDailyLoadsListColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-default btn-xs"
              onClick={() => this.unlinkDailyLoadCarrier(rows.row._original.id)}
            >
              {I18n.t('BEE608' /* Desvincular */)}
            </button>
          </div>
        ),
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'carrier[0].code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        accessor: 'carrier[0].name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE85' /* CNPJ */),
        accessor: 'carrier[0].cnpj',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
      },
    ];

    this.tableCarrierListColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => {
          const carrierCode = rows.original.code;
          const isLinked = this.state.dailyLoadCarrierList.find((dc) => dc.carrier[0].code === carrierCode);

          if (isLinked) {
            return null;
          }
          return (
            <div style={{ textAlign: 'center' }}>
              <button
                type="button"
                className="btn btn-default btn-xs"
                onClick={() => this.linkDailyLoadCarrier(rows.original.id)}
              >
                {I18n.t('BEE601' /* Vincular */)}
              </button>
            </div>
          );
        },
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE85' /* CNPJ */),
        accessor: 'cnpj',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
      },
    ];

    this.state = {
      showAddModal: false,
      dailyLoadCarrierList: [],
      carriersList: [],
    };
  }

  async componentDidMount() {
    await this.getBaseInfo();
  }

  async getBaseInfo() {
    if (this.props.location.state && this.props.location.state.dailyLoad) {
      const { dailyLoad } = this.props.location.state;

      const dailyLoadLabel = `${I18n.t('BEE3937' /* Posição */)}: 
      ${dailyLoad.position} ${I18n.t('BEE145' /* Filial */)}: ${dailyLoad.branch.code} - ${dailyLoad.branch.name}`;

      const baseInfo = await this.props.getDailyLoadCarriers(dailyLoad.position, dailyLoad.branch.code);

      this.setState({
        dailyLoad,
        dailyLoadLabel,
        dailyLoadCarrierList: baseInfo,
      });
    }
  }

  searchCarriers = async () => {
    try {
      const carriersList = await this.props.searchCarriers();

      if (carriersList.length) {
        this.setState({
          carriersList,
          showAddModal: true,
        });
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1163' /* Vincular Transportadora */),
          I18n.t('BEE1159' /* Nenhum item encontrado! */),
          'top-right',
        );
      }
    } catch (error) {
      addNotification(
        'danger',
        I18n.t('BEE1163' /* Vincular Transportadora */),
        I18n.t('BEE1176' /* Erro ao vincular transportadora! */),
        'top-right',
      );
    }
  };

  linkDailyLoadCarrier = async (carrierId) => {
    const { dailyLoad } = this.state;

    try {
      await this.props.linkDailyLoadCarrier(
        carrierId,
        dailyLoad.id,
        dailyLoad.position,
        dailyLoad.branchCode,
      );
      await this.getBaseInfo();

      addNotification(
        'success',
        I18n.t('BEE1163' /* Vincular Transportadora */),
        I18n.t('BEE3970' /* Transportadora vinculada com sucesso! */),
        'top-right',
      );
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE1163' /* Vincular Transportadora */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1163' /* Vincular Transportadora */),
            I18n.t('BEE1176' /* Erro ao vincular transportadora! */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1163' /* Vincular Transportadora */),
          I18n.t('BEE1176' /* Erro ao vincular transportadora! */),
          'top-right',
        );
      }
    }
  };

  linkAll = async () => {
    const { carriersList, dailyLoadCarrierList } = this.state;
    const unlinkedCarriers = carriersList.filter((d) => !dailyLoadCarrierList.find((dc) => dc.carrierCode === d.code));

    await Promise.all(
      unlinkedCarriers.map((carrier) => this.linkDailyLoadCarrier(carrier.id)),
    );
  };

  unlinkDailyLoadCarrier = async (id) => {
    try {
      await this.props.unlinkDailyLoadCarrier(id);
      await this.getBaseInfo();

      addNotification(
        'success',
        I18n.t('BEE1163' /* Vincular Transportadora */),
        I18n.t('BEE4158' /* A transportadora foi desvinculada com sucesso. */),
        'top-right',
      );
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE1163' /* Vincular Transportadora */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1163' /* Vincular Transportadora */),
            I18n.t('BEE1176' /* Erro ao vincular transportadora! */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1163' /* Vincular Transportadora */),
          I18n.t('BEE1176' /* Erro ao vincular transportadora! */),
          'top-right',
        );
      }
    }
  };

  closeAddModal = () => {
    this.setState({
      showAddModal: false,
      carriersList: [],
    });
  };

  render() {
    const {
      dailyLoadLabel, showAddModal, dailyLoadCarrierList, carriersList,
    } = this.state;

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE13' /* Administração */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE3933' /* Carregamentos Diários */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE2377' /* Vincular Transportadoras */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {I18n.t('BEE2377' /* Vincular Transportadoras */)}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <form onSubmit={(e) => e.preventDefault()}>
              <Table
                headerTitle={dailyLoadLabel}
                actionButtons={(
                  <>
                    <button
                      type="button"
                      className="ml-auto btn btn-success btn-sm btn-rounded pl-2 pr-3"
                      onClick={this.searchCarriers}
                    >
                      <i className="fa fa-link mr-1" />
                      {I18n.t('BEE1163' /* Vincular Transportadora */)}
                    </button>

                    <Link to={{ pathname: ROUTES.DAILY_SHIPMENT_LIST, state: { dice: this.props.location.dice } }}>
                      <button type="button" className="btn btn-sm btn-danger btn-rounded ml-3">
                        {I18n.t('BEE137' /* Voltar */)}
                      </button>
                    </Link>
                  </>
                )}
                panelHeaderProps={{
                  onClickReload: () => this.getBaseInfo(),
                }}
                filterable
                data={dailyLoadCarrierList}
                columns={this.tableDailyLoadsListColumns}
                expander
                defaultPageSize={10}
                defaultSorted={this.defaultSorted}
                defaultFilterMethod={(filter, row) => {
                  const input = _.lowerCase(filter.value);
                  const value = _.lowerCase(row[filter.id]);
                  if (_.includes(value, input)) {
                    return true;
                  }
                }}
              />
            </form>
          </div>
        </div>
        <Modal size="xl" isOpen={showAddModal} toggle={() => this.closeAddModal()}>
          <ModalHeader toggle={() => this.closeAddModal()}>{I18n.t('BEE1178' /* Buscar Transportadora */)}</ModalHeader>

          <ModalBody>
            <Table
              headerTitle={dailyLoadLabel}
              filterable
              data={carriersList}
              columns={this.tableCarrierListColumns}
              expander
              defaultPageSize={5}
              defaultSorted={this.defaultSorted}
              defaultFilterMethod={(filter, row) => {
                const input = _.lowerCase(filter.value);
                const value = _.lowerCase(row[filter.id]);
                if (_.includes(value, input)) {
                  return true;
                }
              }}
            />
          </ModalBody>
          <ModalFooter>
            <OneClickButton
              type="button"
              className="btn btn-120 btn-white p-5 m-5"
              onClick={() => this.closeAddModal()}
            >
              {I18n.t('BEE553' /* Fechar */)}

            </OneClickButton>
            {/* <OneClickButton
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={() => this.linkAll()}
            >
              {I18n.t('BEE1158'  Vincular Todas )}

            </OneClickButton> */}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getDailyLoadCarriers: (position, branchCode) => dispatch(getDailyLoadCarriers(position, branchCode)),
  searchCarriers: () => dispatch(searchCarriers()),
  linkDailyLoadCarrier: (
    carrierId,
    dailyLoadId,
    position,
    branchCode,
  ) => dispatch(linkDailyLoadCarrier(
    carrierId,
    dailyLoadId,
    position,
    branchCode,
  )),
  unlinkDailyLoadCarrier: (dailyLoadCarrierId) => dispatch(unlinkDailyLoadCarrier(dailyLoadCarrierId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CarrierLinkDailyLoadsForm));
